import { render, staticRenderFns } from "./MemberBadge.vue?vue&type=template&id=44fd9699&scoped=true&"
import script from "./MemberBadge.vue?vue&type=script&lang=ts&"
export * from "./MemberBadge.vue?vue&type=script&lang=ts&"
import style0 from "./MemberBadge.vue?vue&type=style&index=0&id=44fd9699&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fd9699",
  null
  
)

export default component.exports